//@flow
import type { StateType } from '../reducers';

export const walletForfeitureDataSelector = (state: StateType): Object => state.wallet.walletForfeitureData;
